export default __webpack_public_path__ + "static/media/teamprofile.bd65306d.png";